module.exports = __webpack_public_path__ + "img/career-share.fd5ec708.svg";